export function fetchNewsRT() {
    return new Promise((resolve, reject) => {
        fetch('https://russian.rt.com/listing/tag.olimpic2018-main-material/prepare/json/50/0', {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit'
        }).then(res => res.json(res)
        ).then(json => resolve(json.docs)
        ).catch(err => reject(err));
    });
}

export function fetchPhotosRT() {
    return new Promise((resolve, reject) => {
        fetch('https://russian.rt.com/listing/type.MediaOlympic.tag.olimpiiskie-igry/prepare/json/9/0', {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit'
        }).then(res => res.json(res)
        ).then(json => resolve(json.docs)
        ).catch(err => reject(err));
    });
}



// WEBPACK FOOTER //
// ./src/api/rt-mobile.js